export const myEduInternTranslations = {
  lv: {
    title: 'Mani praktikanti',
    group: 'Mans darbs',
    description:
      'Šeit ir tikai tie praktikanti, kurus jums piešķīris pārvaldnieks. Citu izglītības iestādes prakses vadītāju praktikantus neredzat. Sarakstā ir arī prakses, kas beigušās pēdējo 60 dienu laikā.',
    availability:
      'Pašlaik pieejams praktikantu saraksts un prakses apraksts. Grupas, prakses vietas, pēdējie ieraksti, vērtējumi, stundas un līgumi būs pieejami, kad būs tabulas galapunkts.',
    unavailable: 'Šie dati pašlaik nav pieejami.',
    all: 'Visi mani',
    withoutPlace: 'Bez prakses vietas',
    late: 'Kavē ierakstus',
    supervisor: 'Prakses vadītājs',
    me: '(es)',
    search: 'Meklēt pēc praktikanta vārda, uzvārda…',
    columns: {
      intern: 'Praktikants',
      group: 'Grupa',
      internship: 'Prakse',
      org: 'Prakses vieta',
      lastRecord: 'Pēdējais ieraksts',
      graded: 'Novērtēti',
      hours: 'Stundas',
      agreement: 'Līgums',
    },
  },
  en: {
    title: 'My interns',
    group: 'My work',
    description:
      'Only interns assigned to you by the manager appear here. Other education supervisors’ interns are not visible. Internships that ended within the last 60 days are also included.',
    availability:
      'The intern list and internship description are currently available. Groups, workplaces, latest entries, grades, hours and agreements require the table endpoint.',
    unavailable: 'This information is not available yet.',
    all: 'All mine',
    withoutPlace: 'Without a workplace',
    late: 'Late entries',
    supervisor: 'Supervisor',
    me: '(me)',
    search: 'Search by intern’s first or last name…',
    columns: {
      intern: 'Intern',
      group: 'Group',
      internship: 'Internship',
      org: 'Workplace',
      lastRecord: 'Latest entry',
      graded: 'Graded',
      hours: 'Hours',
      agreement: 'Agreement',
    },
  },
}
